import { DialogService, GridButton } from '@eforall/dashboard';
import { DialogMode } from '@interfaces';
import { EngagementInteractionFormDialog, EngagementInteractionFormDialogData } from '../../../../dialog';
import { EngagementViewerDialogService } from '../../engagement-viewer.service';



export function getButtons(pageService: EngagementViewerDialogService, dialogService: DialogService) {

	const buttons: GridButton[] = [
		{
			iconClass: 'fa-plus',
			label: 'Add engagement request',
			execute: async () => {
				const dialogData: EngagementInteractionFormDialogData = {
					mode: DialogMode.ADD,
					engagementId: pageService.engagementDetails()?.engagementId || 0,
					engagementContactId: undefined
				}
				await dialogService.showCustom(EngagementInteractionFormDialog, { data: dialogData }, 550, 550);
				await pageService.getEngagementDetails(dialogData.engagementId);
			}
		},
		{
			iconClass: 'fa-refresh',
			label: 'Refresh',
			execute: async () => {
				const engagement = pageService.engagementDetails();
				if (engagement && engagement.engagementId) {
					return await pageService.getEngagementDetails(engagement.engagementId);
				}
			}
		},
	];

	return buttons;
}